import styled from '@emotion/styled';

import { mobileOnly } from 'styles/mixins/displayMobileDesktop';
import { LOCAL_COLORS } from 'styles/constants';

export const Container = styled.div`
  display: flex;
  margin-bottom: -2px;
  width: 100%;
  ${mobileOnly('flex', 'lgUp')}
`;

export const LeftBox = styled.div`
  background-color: ${LOCAL_COLORS.surfaceBrandBold};
  flex-basis: 0;
  flex-grow: 1;
`;
